import styled from 'styled-components';
import { ModalSaveTemplate } from './ModalSaveTemplate';
import { GlobalStyled } from '@components/Modal/ModalSave/shared/GlobalStyled';

export const ModalSave = styled(ModalSaveTemplate)`
    ${GlobalStyled}
`;
